import { cn } from '@/lib/utils';

export function TypographyH1({
  children,
  className,
  ...props
}: React.HTMLAttributes<HTMLHeadingElement> & { children: React.ReactNode }) {
  return (
    <h1
      className={cn('scroll-m-20 text-4xl font-extrabold tracking-tight text-balance', className)}
      {...props}
    >
      {children}
    </h1>
  );
}

export function TypographyH2({
  children,
  className,
  ...props
}: React.HTMLAttributes<HTMLHeadingElement> & { children: React.ReactNode }) {
  return (
    <h2
      className={cn('scroll-m-20 text-3xl font-semibold tracking-tight text-balance', className)}
      {...props}
    >
      {children}
    </h2>
  );
}

export function TypographyH3({
  children,
  className,
  ...props
}: React.HTMLAttributes<HTMLHeadingElement> & { children: React.ReactNode }) {
  return (
    <h3
      className={cn('scroll-m-20 text-2xl font-semibold tracking-tight text-balance', className)}
      {...props}
    >
      {children}
    </h3>
  );
}

export function TypographyH4({
  children,
  className,
  ...props
}: React.HTMLAttributes<HTMLHeadingElement> & { children: React.ReactNode }) {
  return (
    <h4
      className={cn('scroll-m-20 text-xl font-semibold tracking-tight text-balance', className)}
      {...props}
    >
      {children}
    </h4>
  );
}

export function TypographyH5({
  children,
  className,
  ...props
}: React.HTMLAttributes<HTMLHeadingElement> & { children: React.ReactNode }) {
  return (
    <h5
      className={cn('scroll-m-20 text-lg font-semibold tracking-tight text-balance', className)}
      {...props}
    >
      {children}
    </h5>
  );
}
export function TypographyH6({
  children,
  className,
  ...props
}: React.HTMLAttributes<HTMLHeadingElement> & { children: React.ReactNode }) {
  return (
    <h6
      className={cn('scroll-m-20 text-base font-semibold tracking-tight text-balance', className)}
      {...props}
    >
      {children}
    </h6>
  );
}
